import React, { FC, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { profileAccountService } from "../../../store/actions";

interface EditTagModalProps {
  show: boolean;
  onClose: () => void;
  tagItem: TransactionTag;
  onSuccess: () => void;
}

interface TransactionTag {
  tag_name: string;
  transaction_hash: string;
  id: string;
}

const EditTagModal: FC<EditTagModalProps> = ({
  show,
  onClose,
  tagItem,
  onSuccess
}) => {
  const [name, setName] = useState(tagItem.tag_name);
  const [hash, setHash] = useState(tagItem.transaction_hash);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const _account = useSelector((e: Object) => (e as any)?.common?.account);
  const signature = _account?.signature;
  const message = _account?.message;

  const handleSubmit = async () => {
    if (!tagItem.transaction_hash) {
      setError('Invalid Transaction details');
      return;
    }

    if (!name.trim()) {
      setError('Tag name cannot be empty');
      return;
    }

    try {
      setIsSubmitting(true);
      setError(null);

      await profileAccountService.updateTransactionTag({
        name: name.trim(),
        hash: tagItem.transaction_hash,
        tagId: tagItem.id,
        message,
        signature,
      });

      onSuccess();
      onClose();
    } catch (err) {
      console.error('Error updating tag:', err);
      setError('Failed to update tag. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onClose} animation={true}>
      <Modal.Header closeButton>
        <Modal.Title>
          <h5 className="modal-title fw-medium">Edit Private Transaction Tag</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-lg-12">
            <div className="bs-field mb-3">
              <label htmlFor="hash" className="form-label">Transaction Hash</label>
              <input
                type="text"
                id="hash"
                className="form-control"
                value={hash}
                readOnly
              />
            </div>
            
            <div className="bs-field mb-3">
              <label htmlFor="name" className="form-label">Private Transaction Tag</label>
              <input
                type="text"
                id="name"
                className="form-control"
                placeholder="e.g. Donation Transaction"
                maxLength={35}
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
              <small className="form-text text-muted">
                Character limit: {name.length} / 35.
              </small>
            </div>
            
            {error && <div className="alert alert-danger">{error}</div>}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer className="bg-light">
        <button 
          className="btn btn-ghost-white" 
          onClick={onClose} 
          disabled={isSubmitting}
        >
          Cancel
        </button>
        <Button 
          onClick={handleSubmit} 
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Updating...' : 'Update Private Name Tag'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditTagModal;